// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list {
  width: -moz-fit-content;
  width: fit-content;
  height: 0px;
  overflow: hidden;
  transition: height 0.4s;
  position: absolute;
  right: 0;
  z-index: 88888888;
  background-color: var(--color-white-light);
}

.column-select {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  background: var(color-white-dark);
  width: 100%;
  border-radius: 6px;
  cursor: pointer;
}
.column-select p {
  padding-right: 10px;
  cursor: pointer;
  width: 90%;
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 10px;
  color: var(--color-blue-1-dark);
}
.column-select .colchooser-icon {
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  color: var(--color-blue-1-dark);
}

.list-cont {
  position: relative;
  right: 0;
}

.icon-cont {
  height: auto;
  width: auto;
  vertical-align: middle;
}

.active {
  height: -moz-fit-content;
  height: fit-content;
  max-height: 70vh;
  width: max-content;
  overflow-y: scroll;
  border-radius: 10px;
  box-shadow: -1px 0px 5px -2px rgba(0, 0, 0, 0.3);
}

.inactive {
  height: 0px;
}

.checkbox-inline {
  float: right;
  height: 18px;
  width: 18px;
}

.reorder-enabled ion-reorder {
  cursor: move;
  opacity: 0.4;
}

.checkbox-inline:focus-visible {
  outline: none;
}

.sc-ion-label-md-h {
  font-size: 14px;
}

/* dark theme styles */
.column-select.dark {
  background: var(color-white-dark);
}

.dark .list {
  background-color: var(--color-white-dark);
}
.dark p {
  color: var(--color-blue-1-dark);
}
.dark .colchooser-icon {
  color: var(--color-black-dark) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/column-selector/column-selector.component.scss","webpack://./../../../../../Ryan%20Ticer/source/repos/seacom3/ui/src/app/components/column-selector/column-selector.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EAAA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,0CAAA;ACCJ;;ADEA;EACI,aAAA;EACA,sBAAA;EAEA,2BAAA;EACA,qBAAA;EAEA,iCAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;ACDJ;ADGI;EACI,mBAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;ACDR;ADII;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;ACFR;;ADMA;EACI,kBAAA;EACA,QAAA;ACHJ;;ADMA;EACI,YAAA;EACA,WAAA;EACA,sBAAA;ACHJ;;ADMA;EACI,wBAAA;EAAA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EAGA,gDAAA;ACHJ;;ADMA;EACI,WAAA;ACHJ;;ADMA;EACI,YAAA;EACA,YAAA;EACA,WAAA;ACHJ;;ADOA;EACI,YAAA;EACA,YAAA;ACJJ;;ADOA;EACI,aAAA;ACJJ;;ADOA;EACI,eAAA;ACJJ;;ADOA,sBAAA;AACA;EACI,iCAAA;ACJJ;;ADQI;EACI,yCAAA;ACLR;ADQI;EACI,+BAAA;ACNR;ADSI;EACI,yCAAA;ACPR","sourcesContent":[".list {\r\n    width: fit-content;\r\n    height: 0px;\r\n    overflow: hidden;\r\n    transition: height 0.4s;\r\n    position: absolute;\r\n    right: 0;\r\n    z-index: 88888888;\r\n    background-color: var(--color-white-light);\r\n}\r\n\r\n.column-select {\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    justify-content: flex-start;\r\n    align-items: flex-end;\r\n\r\n    background: var(color-white-dark);\r\n    width: 100%;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n\r\n    p {\r\n        padding-right: 10px;\r\n        cursor: pointer;\r\n        width: 90%;\r\n        font-size: 18px;\r\n        margin-top: 10px;\r\n        margin-bottom: 10px;\r\n        color: var(--color-blue-1-dark);\r\n    }\r\n\r\n    .colchooser-icon {\r\n        display: block;\r\n        max-width: 100%;\r\n        max-height: 100%;\r\n        width: auto;\r\n        height: auto;\r\n        color: var(--color-blue-1-dark);\r\n    }\r\n}\r\n\r\n.list-cont {\r\n    position: relative;\r\n    right: 0;\r\n}\r\n\r\n.icon-cont {\r\n    height: auto;\r\n    width: auto;\r\n    vertical-align: middle;\r\n}\r\n\r\n.active {\r\n    height: fit-content;\r\n    max-height: 70vh;\r\n    width: max-content;\r\n    overflow-y: scroll;\r\n    border-radius: 10px;\r\n    -webkit-box-shadow: -1px 0px 5px -2px rgb(0 0 0 / 75%);\r\n    -moz-box-shadow: -1px 0px 5px -2px rgba(0, 0, 0, 0.75);\r\n    box-shadow: -1px 0px 5px -2px rgb(0 0 0 / 30%);\r\n}\r\n\r\n.inactive {\r\n    height: 0px;\r\n}\r\n\r\n.checkbox-inline {\r\n    float: right;\r\n    height: 18px;\r\n    width: 18px;\r\n}\r\n\r\n\r\n.reorder-enabled ion-reorder {\r\n    cursor: move;\r\n    opacity: 0.4;\r\n}\r\n\r\n.checkbox-inline:focus-visible {\r\n    outline: none\r\n}\r\n\r\n.sc-ion-label-md-h {\r\n    font-size: 14px;\r\n}\r\n\r\n/* dark theme styles */\r\n.column-select.dark {   \r\n    background: var(color-white-dark);\r\n}\r\n\r\n.dark {\r\n    .list {\r\n        background-color: var(--color-white-dark);\r\n    }\r\n\r\n    p {\r\n        color: var(--color-blue-1-dark);\r\n    }\r\n\r\n    .colchooser-icon {\r\n        color: var(--color-black-dark) !important;\r\n    }\r\n}\r\n",".list {\n  width: fit-content;\n  height: 0px;\n  overflow: hidden;\n  transition: height 0.4s;\n  position: absolute;\n  right: 0;\n  z-index: 88888888;\n  background-color: var(--color-white-light);\n}\n\n.column-select {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-end;\n  background: var(color-white-dark);\n  width: 100%;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.column-select p {\n  padding-right: 10px;\n  cursor: pointer;\n  width: 90%;\n  font-size: 18px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  color: var(--color-blue-1-dark);\n}\n.column-select .colchooser-icon {\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  color: var(--color-blue-1-dark);\n}\n\n.list-cont {\n  position: relative;\n  right: 0;\n}\n\n.icon-cont {\n  height: auto;\n  width: auto;\n  vertical-align: middle;\n}\n\n.active {\n  height: fit-content;\n  max-height: 70vh;\n  width: max-content;\n  overflow-y: scroll;\n  border-radius: 10px;\n  -webkit-box-shadow: -1px 0px 5px -2px rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: -1px 0px 5px -2px rgba(0, 0, 0, 0.75);\n  box-shadow: -1px 0px 5px -2px rgba(0, 0, 0, 0.3);\n}\n\n.inactive {\n  height: 0px;\n}\n\n.checkbox-inline {\n  float: right;\n  height: 18px;\n  width: 18px;\n}\n\n.reorder-enabled ion-reorder {\n  cursor: move;\n  opacity: 0.4;\n}\n\n.checkbox-inline:focus-visible {\n  outline: none;\n}\n\n.sc-ion-label-md-h {\n  font-size: 14px;\n}\n\n/* dark theme styles */\n.column-select.dark {\n  background: var(color-white-dark);\n}\n\n.dark .list {\n  background-color: var(--color-white-dark);\n}\n.dark p {\n  color: var(--color-blue-1-dark);\n}\n.dark .colchooser-icon {\n  color: var(--color-black-dark) !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
